import { jsx as i } from "react/jsx-runtime";
import { ToastContainer as t } from "react-toastify";
const n = () => /* @__PURE__ */ i("div", { className: "notification-container-wrapper", children: /* @__PURE__ */ i(t, { className: "notification-container", stacked: !1, limit: 5 }) });
export {
  n as default
};
//# sourceMappingURL=NotificationsContainer.js.map
